import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    TopToolbar,
    EditButton,
    useRecordContext,
} from 'react-admin';
import {
    Grid
} from '@mui/material';

const ShowActions = () => {
    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowUrlTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{ "Url - " + record.id }</span>
}

export const AdminTelephoneShow = () => {

    return(
        <Show actions={ <ShowActions /> } title={ <ShowUrlTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id"/>
                        <TextField source="telephone" />
                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="description" />
                        <ReferenceField
                            source="company"
                            reference="companies"
                            link="edit"
                        >
                            <TextField source="name"/>
                        </ReferenceField>
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}